import React, { Component } from 'react'
import { TweenMax, Back, TimelineMax, Power2, Power4, Sine } from 'gsap';
//import ScrollMagic from '../../ScrollMagic';
import ScrollMagic from 'ScrollMagic';
import 'animation.gsap';
import './style.scss';
export default class qintroHeader extends Component {
    
    componentDidMount(){
        //let el = this.divStdHeaderBgWrap;
        //let el1 = this.divHeroContent
        //console.log(el);
        // TweenMax.from(el, .8, {
        //     autoAlpha: 0,
        //     x: 0,
        //     y: 50,
        //     rotationX: -50,
        //     transformOrigin: "center 0%",
        //     ease: Back.easeOut
        // }, "-=0.4");


        // TweenMax.set(this.divHeroContent, {
        //     perspective: 500
        // });
        
        // TweenMax.to(this.divHeroContent, 1, {
        //     y: -200,
        //     opacity: 0,
        //     ease: Power1.easeOut
        // }, "-=1");

        TweenMax.set(this.divStdHeaderBgWrap, {
            transformPerspective: 1e3
        });
        
        TweenMax.set(this.divHeroContent, {
            perspective: 500
        })

            let i = new TimelineMax;

            i.set([this.divHeroListLineOne, this.divHeroListLineTwo], {
                autoAlpha: 1
            }).from(this.divHeroTitle, .8, {
                autoAlpha: 0,
                x: 0,
                y: 50,
                rotationX: -50,
                transformOrigin: "center 0%",
                delay: 2,
                ease: Back.easeOut
            }, "-=0.4").from(this.divHeroListLineOne, .3, {
                scaleX: 0,
                y: 25,
                ease: Power2.easeOut,
                transformOrigin: "center center"
            }, "-=0.8").from(this.divHeroListLineTwo, .3, {
                scaleX: 0,
                y: -25,
                ease: Power2.easeOut,
                transformOrigin: "center center"
            }, "-=0.8").from(this.divHeroList, .6, {
                y: 25,
                autoAlpha: 0,
                ease: Power2.easeOut
            }, "-=0.5").from(this.divStdHeaderBgWrap, 4, {
                rotationX: 25,
                autoAlpha: 0,
                y: 0,
                transformOrigin: "center 0%",
                ease: Power4.easeOut
            }, "-=2.2");


            // var t = new TimelineMax();
            // t.to(this.divStdHeaderBgWrap, 1, {
            //     //scale: 1.5,
            //     opacity: .1,
            //     transformOrigin: "center center",
            //     ease: Sine.easeInOut
            // }).to(this.divHeroContent, 1, {
               
            //     opacity: 0.5,
            //     ease: Power1.easeOut
            // }, "-=1");


            


            // var controller = new ScrollMagic.Controller({
            //     globalSceneOptions: {
                
            //     }
            //   });

            // new ScrollMagic.Scene({
            //     triggerElement: this.divHero,
            //     triggerHook: 0,
            //     duration: "100%"
            // }).setTween(t).addTo(controller);
        
    }
  render() {
    return (
        <div style={{ marginBottom:'3rem' }}>

            <div className="post-title">
                <div className="pageHeading">
                    <div className="project-title">
                        {/* <h5>Case Studies</h5> */}
                        <h3 style={{ fontSize:'8rem' }} dangerouslySetInnerHTML={{__html: this.props.title}}></h3>
                        {/* <p style={{ fontSize:'2rem' }}>{this.props.pathContext.description}</p> */}
                    </div>
                </div>
            </div>


            <section className="hero post-hero" ref={e=> this.divHero = e}>
                
                <div className="hero__content" ref={e => this.divHeroContent = e}>
                <div className="post-hero-wrapper" style={{ display:'none' }}>
                    <h1 className="hero_title" ref={e => this.divHeroTitle = e}>{this.props.title}</h1>
                    <div className="hero__list-wrap" ref={e => this.divHeroListWrap = e}>
                                <div className="hero__list-line"  ref={e => this.divHeroListLineOne = e}></div>
                                                <ul className="hero__list" ref={e => this.divHeroList = e}>
                                                                {/* <li className="hero__list-item" ref={e => this.divHeroListItem = e}>{this.props.type}</li> */}
                                                            
                                                                {/* <li ref={e => this.divHeroListItem = e} className="hero__list-item">A whole lot of fun</li> */}
                                                                
                                                        </ul>
                            
                            <div className="hero__list-line" ref={e => this.divHeroListLineTwo = e} ></div>
                        </div>

                        </div>
                    </div>
                    <div className="std-header__bg-wrap" ref={e => this.divStdHeaderBgWrap = e}>
                    
                        <img src={this.props.bg.src} srcSet={this.props.bg.srcSet} className="std-header__bg cover wp-post-image" alt="product page" /> 
                </div>

            
        </section>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PostIntro/index.js